import styled from '@emotion/styled';

export const Wrapper = styled.footer`
  position: relative;
  bottom: 0;
  background: ${props => props.theme.colors.gray};
  font-family: ${props => props.theme.fontFamily.footer};
  padding: 2rem;

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    padding: 20px;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: column;

  @media (max-width: ${props => props.theme.breakpoints.l}) {
    flex-direction: column-reverse;
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    align-items: flex-end;
  }
`;

export const Columns = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-evenly;
  width: 100%;

  @media (max-width: ${props => props.theme.breakpoints.l}) {
    justify-content: space-between;
  }
`;

export const Nav = styled.div`
  width: 76%;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    width: 90%;
  }
`;

export const Links = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  text-align: left;
  margin-right: 30px;
  min-width: 150px;

  @media (max-width: ${props => props.theme.breakpoints.m}) {
    flex-direction: column;
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    min-width: 130px;
  }

  p {
    @media (max-width: ${props => props.theme.breakpoints.s}) {
      font-size: ${props => props.theme.textSize.s};
      line-height: normal;
    }
  }

  a {
    color: ${props => props.theme.colors.black};
  }
`;

export const ActionLink = styled.a`
  cursor: pointer;
`;
export const Copyright = styled.p`
  text-align: center;
  margin-bottom: 0;

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    font-size: ${props => props.theme.textSize.s};
    line-height: normal;
  }
`;

export const Section = styled.section`
  @media (max-width: ${props => props.theme.breakpoints.s}) {
    display: none;
  }

  &.visible {
    display: block;
  }
`;

export const TitleArrow = styled.span`
  font-size: 10px;
  display: none;
  margin-left: 5px;

  &.active {
    transform: rotate(180deg);
    position: relative;
    bottom: 2px;
  }

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    display: inline-block;
  }
`;
